<div class="sidenav-content">
  <div class="bcontainer2">
    <div class="main-content">


    <div class="spacer2"></div>

    <div class="containter">
      <div class="mfhd">
        <i
          class="fa fa-angle-left"
          aria-hidden="true"
          style="padding-right: 5px"
        ></i
        >Workspaces
        <div
          class="page-description"
          style="
            color: #9c9b9b;
            font-size: 14px;
            margin-top: 8px;
            margin-bottom: 16px;
          "
        >
          A workspace keeps your interactions, memories, graphs, and reminders
          grouped in one place—nice and tidy.
        </div>
      </div>

     
        <!--<button
          mat-raised-button
          color="primary"
          [routerLink]="['/create-apikey']"
          class="btn-send clr-white"
          style="float: right"
          title="Create new workspace"
        >
          +
          Create
        </button>-->

      <div class="spacer2"></div>
      <div class="clear"></div>

 <div class="example-container">
        <table
          mat-table
          [dataSource]="workspaces"
          class="mat-elevation-z8"
          multiTemplateDataRows
        >
          <ng-container matColumnDef="workspaceName">
            <th mat-header-cell *matHeaderCellDef>Workspace</th>
            <td mat-cell *matCellDef="let element">
              <a                
                class="pointer routeClr"
                (click)="configKey(element.workspaceId, element.workspaceName, element.apiKey)"
              >
                {{ element.workspaceName }}
              </a>

              <i
                *ngIf="element.workspaceName === appService.workspaceName"
                class="fa-solid fa-check"
                style="color: #15b300; padding-left: 5px"
              ></i>
            </td>
          </ng-container>

          <ng-container matColumnDef="apiKey">
            <th mat-header-cell *matHeaderCellDef>API Key</th>
            <td mat-cell *matCellDef="let element">
              <div class="min fl-left" id="myInput">
                {{ maskApiKey(element.apiKey) }}
              </div>
              <i
                class="fa-solid fa-clone pointer fl-left routeClr"
                [matTooltip]="getCopyTooltip(element.apiKey)"
                (click)="copyMessage(element.apiKey)"
                style="margin-left: 3px"
              ></i>
            </td>
          </ng-container>

          <ng-container matColumnDef="status">
            <th mat-header-cell *matHeaderCellDef>Status</th>
            <td mat-cell *matCellDef="let element">{{ element.status }}</td>
          </ng-container>

          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Created On</th>
            <td mat-cell *matCellDef="let element">
              {{
                element.createdAt
                  | tzfmt : "yyyy-MM-dd HH:mm:ss" : appService.TimeZoneName
              }}
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
          <tr
            mat-row
            *matRowDef="let row; columns: displayedColumns"
            class="main-row"
          ></tr>

        <!-- No data message -->
        <tr class="mat-row" *matNoDataRow>
          <td class="mat-cell" [attr.colspan]="displayedColumns.length" style="text-align: center; height: 50vh;">
            {{ loading ? 'Loading...' : 'No data found' }}
          </td>
        </tr>

        </table>

      </div>
    </div>

    <div class="spacer5"></div>

    </div>
  </div>
</div>
